import script from "./messageSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./messageSetting.vue?vue&type=script&setup=true&lang=js"

import "./messageSetting.vue?vue&type=style&index=0&id=cdb66362&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb66362"]])

export default __exports__